/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
              'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
              'BIPARTITE_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFOR',
              'BIPARTITE_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
              'BIPARTITE_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_observe_any_of_the_following_practices_related_to: valueSchema,
  },
}
